import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [formState, setFormState] = useState();
  const { language } = useLanguage();
  const t = translations.contact[language] || translations.contact.en;
  const tf = translations.footer[language] || translations.footer.en;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormState("pending");

    try {
      const response = await fetch("https://formsubmit.co/ajax/parminder@9reason.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          message,
          _cc: "ghuman1986@gmail.com",
          _subject: `New Contact from 9Reason Website - ${name}`,
        }),
      });

      const result = await response.json();

      if (result.success === "true" || response.ok) {
        setFormState("success");
        setState(initialState);
      } else {
        setFormState("error");
      }
    } catch (err) {
      console.error(err);
      setFormState("error");
    }
  };

  return (
    <>
      <section id="contact">
        <div className="container">
          <div className="section-header">
            <span className="section-label">{language === 'en' ? 'Get in Touch' : language === 'hi' ? 'संपर्क करें' : language === 'pa' ? 'ਸੰਪਰਕ ਕਰੋ' : 'Contactez-nous'}</span>
            <h2 className="section-title">{t.title}</h2>
            <p className="section-description">
              {t.subtitle}
            </p>
          </div>
          <div className="contact-grid">
            <div className="contact-form">
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder={t.namePlaceholder}
                      required
                      value={name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder={t.emailPlaceholder}
                      required
                      value={email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    className="form-control"
                    rows="5"
                    placeholder={t.messagePlaceholder}
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                </div>
                {formState === "success" && (
                  <div id="success">
                    {t.successMessage}
                  </div>
                )}
                {formState === "error" && (
                  <div id="error">
                    {t.errorMessage}
                  </div>
                )}
                <button type="submit" className="btn-submit" disabled={formState === "pending"}>
                  {formState === "pending" ? t.sending : `${t.sendButton} →`}
                </button>
              </form>
            </div>
            <div className="contact-info">
              <h3>{language === 'en' ? 'Contact Info' : language === 'hi' ? 'संपर्क जानकारी' : language === 'pa' ? 'ਸੰਪਰਕ ਜਾਣਕਾਰੀ' : 'Coordonnées'}</h3>
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div className="contact-item-content">
                  <span>{t.address}</span>
                  <p>{props.data ? props.data.address : "loading"}</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div className="contact-item-content">
                  <span>{t.phone}</span>
                  <p>{props.data ? props.data.phone : "loading"}</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">✉️</div>
                <div className="contact-item-content">
                  <span>{t.email}</span>
                  <p>{props.data ? props.data.email : "loading"}</p>
                </div>
              </div>
              <div className="social-links">
                <a href={props.data ? props.data.facebook : "/"} className="social-link" target="_blank" rel="noopener noreferrer">
                  <span>f</span>
                </a>
                <a href={props.data ? props.data.twitter : "/"} className="social-link" target="_blank" rel="noopener noreferrer">
                  <span>𝕏</span>
                </a>
                <a href={props.data ? props.data.youtube : "/"} className="social-link" target="_blank" rel="noopener noreferrer">
                  <span>▶</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer id="footer">
        <div className="container">
          <p>{tf.copyright}</p>
        </div>
      </footer>
    </>
  );
};
